export const meterPercent = (dbfs: number, floor = -60): number => Math.max(0, Math.min(100, ((dbfs - floor) / -floor) * 100));
export const faderPercent = (db: number): number => {
  const clamped = Math.max(-60, Math.min(12, db));
  if (clamped >= -12) return 70 + ((clamped + 12) / 24) * 30;
  return ((clamped + 60) / 48) * 70;
};
export const percentToFaderDb = (percent: number): number => {
  const p = Math.max(0, Math.min(100, percent));
  return p >= 70 ? -12 + ((p - 70) / 30) * 24 : -60 + (p / 70) * 48;
};
